// react
import { useEffect, useReducer } from "react";

// api
import GetInventoryUIData from "./api/initial";

// context
import { InitialProvider } from "./context/InitialContext";
import {
  initialReducer,
  initialInventoryUIDetails,
} from "./context/initialReducer";

// components
import Page from "./components/Page";

const App = () => {
  const [initialState, initialDispatch]: [
    initialState: any,
    initialDispatch: any,
  ] = useReducer(initialReducer, initialInventoryUIDetails);

  const GetInventoryUIDataHandler = () =>
    GetInventoryUIData().then((data: any) =>
      initialDispatch({
        type: "SET_INITIAL_DATA",
        payload: data,
      }),
    );

  useEffect(() => {
    GetInventoryUIDataHandler();
    // eslint-disable-next-line
  }, []);

  return (
    <InitialProvider value={{ initialState, initialDispatch }}>
      <Page />
    </InitialProvider>
  );
};

export default App;
